import React, { useEffect, useMemo } from 'react';
import styles from './index.module.scss';
import close from '../../../assets/images/close.svg';
import { callFlutterHandler } from '../../../utils/flutterBridge';
import { ctLogV2 } from '../../../utils/cleverTapLogger.utils';
import { useIdHash } from '../../../hooks/custom.hooks';

function DetailsPage() {
  const detailsData = useMemo(() => {
    const stored = localStorage.getItem('selectedDynamicOffers');
    return stored ? JSON.parse(stored) : [];
  }, []);
  const { custId: cid } = useIdHash();

  useEffect(() => {
    if (detailsData && cid) {
      ctLogV2({
        eventName: 'appOfferDetailsPageFromHomepageViewed',
        customerId: cid,
        extraData: {
          offerId: detailsData?.offer_id || null,
          brandId: detailsData?.brand_id || null,
        },
      });
    }
  }, [cid, detailsData]);

  return (
    <>
      <div className={styles.pageContainer}>
        <div className={styles.headerSection}>
          <div className={styles.heading}>Offer Details</div>
          <img
            src={close}
            alt="close"
            style={{ cursor: 'pointer' }}
            onClick={() => {
              localStorage.removeItem('selectedDynamicOffers');
              callFlutterHandler('backButton');
            }}
          />
        </div>
        <div className={styles.contentScrollSection}>
          <div className={styles.brandImageContainer}>
            <img
              // src={detailsData?.offer_image}
              src={`${detailsData?.offer_image}?v=1.0.1`}
              alt="logo"
              className={styles.brandLogo}
            />
            <div className={styles.title}>{detailsData?.offer_title}</div>
            <div className={styles.subTitle}>{detailsData?.offer_subtitle}</div>
          </div>
          {/* How to Redeem?  */}
          {Number(detailsData?.how_to_redeem_flag) === 1 && (
            <div className={styles.redeemContent}>
              <div className={styles.title}>How to Redeem?</div>
              <div className={styles.separator} />
              <div className={styles.steps}>
                {detailsData?.how_to_redeem?.map((step, index) => (
                  <div key={index} className={styles.step}>
                    <div className={styles.text}>
                      <div className={styles.stepNumber}>STEP {index + 1}</div>
                      <div className={styles.stepTitle}>{step.data}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {/* Tnc Info */}
          <div className={styles.TndC}>
            <div className={styles.title}>Terms & Conditions</div>
            <div className={styles.steps}>
              {detailsData?.tnc?.map((elem, index) => (
                <div key={index} className={styles.step}>
                  <div className={styles.text}>
                    <div className={styles.stepTitle}>{elem}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/*  CTA  */}

          <div
            className={styles.offerBottomContent}
            onClick={() => {
              ctLogV2({
                eventName: 'appOfferDetailsPageFromHomepageClicked',
                customerId: cid,
                extraData: {
                  offerId: detailsData?.offer_id || null,
                  brandId: detailsData?.brand_id || null,
                },
              });
            }}
          >
            <div className={styles.actions}>
              <div className={`${styles.visitBrand}`}>
                <a href={detailsData?.cta_link}>{detailsData?.cta_text}</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default DetailsPage;
